import { render, staticRenderFns } from "./Patch.vue?vue&type=template&id=306341f2&"
import script from "./Patch.vue?vue&type=script&lang=ts&"
export * from "./Patch.vue?vue&type=script&lang=ts&"
import style0 from "./Patch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports